<nav class="bg-[#181636] py-3 px-4 lg:p-5 shrink-0 shadow-sm">
    <div class="container lg:max-w-7xl mx-auto text-center">
        <img
            alt="Main Logo"
            class="shrink-0 h-10 mx-auto aspect-[5/2] object-contain"
            [src]="appStore.customStyling().active? appStore.customStyling().logo_url : '/assets/imgs/unipin-logo-white.svg'"
        />

        @if (appStore.customStyling().active && appStore.customStyling().game_name) {
            <div class="font-bold mt-2">
                {{ appStore.customStyling().game_name }}
            </div>
        }
    </div>
</nav>

<main class="p-5 lg:px-8 lg:py-14 grow overflow-y-auto">
    <router-outlet />
</main>

<footer class="shrink-0 p-4 text-center text-xs text-gray-400 bg-[#181636] leading-6">Copyright &copy; {{ year }} UniPin. All rights reserved. v2.6.0 · {{ fingerprint() }}</footer>
